<template>
  <div>
    <BaseModal :config="docModalConfig">
      <BaseDocumentMgrandDropoff
        ref="distributionDocumentMgr"
        :mgrGridQuery="filterCondition"
        :transactionRecord="transactionRecord"
      ></BaseDocumentMgrandDropoff>
    </BaseModal>
  </div>
</template>

<script>
import BaseDocumentMgrandDropoff from "@/components/base/BaseDocumentMgrandDropoff.vue";
import BaseModal from "@/components/base/BaseModal.vue";

export default {
  name: "DistributionDocumentDropoffForm",
  props: {
    docModalConfig: {},
    filterCondition: {},
    transactionRecord:{}
  },
  components: {
    BaseModal,
    BaseDocumentMgrandDropoff
  },
  data: function() {
    return {
      businessEvent: "Distribution"
    };
  },
  methods: {},
  mounted() {}
};
</script>
